// extracted by mini-css-extract-plugin
module.exports = {"container":"details_container__3nXwY","card":"details_card__1dyNy","row":"details_row__2FkOD","row2":"details_row2__1A4h1","btn":"details_btn__17eoV"};